import styled from '../../../styles/theme';
import { GeoLocationInputStyled } from '../GeoLocationInputStyled';

export const GeoLocationInputStyledAP = styled(GeoLocationInputStyled)`
    .geolocation-title {
        font-weight: bold;
    }

    .Select__control {
        background: ${({ theme }) => theme.colors.black} !important;
        border: 1px solid ${({ theme }) => theme.colors.black} !important;
    }
`;
